import Logger from "../../../_helpers/_logger";
import cc from "classcat";
import { memo } from "react";
import { isEmpty } from "lodash";

export const BotOnButton = memo(({id, className = ""}) => (
	<button
		className={cc(["bob-button", className])}
		id={id}
		onClick={() => {
			if (!isEmpty(className)) {
				Logger.log(`Bot on button .${className} was clicked`);
			} else {
				Logger.log(`Bot on button #${id} was clicked`);
			}
		}}
	/>
));

export const BotsOnButtons = ({ids}) => ids.map((id, index) => <BotOnButton id={id} key={index}/>);
